import { FinanceAccountCreationSuccessContainer } from '../../../containers';

export const FinanceAccountCreationSuccess = () => <FinanceAccountCreationSuccessContainer />;
